export enum EmergencyType {
    EmergencyTriage = 1,
    NursingERForm
}